module.exports = __webpack_public_path__ + "static/media/svg-sprite.e9ca0480.svg";